function checkParent(url) {
  if (!url) return null;
  const parentPATH = url.substring(0, url.lastIndexOf('/'));
  if (parentPATH && parentPATH.length) return parentPATH;
  return null;
}

export default checkParent;
